import React, { useState } from "react";
import Notifications from "./Notifications";
import Certificates from "./Certificates";
import Exams from "./Exams";
import Users from "./Users";

const Dashboard = () => {
  const [tab, setTab] = useState("notification");
  function renderSelected() {
    switch (tab) {
      case "exam":
        return <Exams />;
      case "user":
        return <Users />;
      case "certificate":
        return <Certificates />;
      case "notification":
        return <Notifications />;
      default:
        return <Notifications />;
    }
  }
  return (
    <div>
      <ul className="nav nav-tabs mb-2">
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "notification" && "active"}`}
            onClick={() => setTab("notification")}
          >
            Notifications
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "exam" && "active"}`}
            onClick={() => setTab("exam")}
          >
            Exams
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "user" && "active"}`}
            onClick={() => setTab("user")}
          >
            Students
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${tab === "certificate" && "active"}`}
            onClick={() => setTab("certificate")}
          >
            Certificates
          </button>
        </li>
      </ul>
      {renderSelected()}
    </div>
  );
};

export default Dashboard;
